/**
 * Directive with displaying current count/max count symbols input.
 *
 * @class moviedbToVod
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc directive
 * @name mwApp/common:moviedbToVod
 */
/* @ngInject */
import moment from 'moment'

export function moviedbToVod () {
  return {
    restrict: 'E',
    scope: {
      moviedb: '=',
      vod: '=',
      currentVodState: '=',
      update: '=',
      search: '=',
    },
    link: function (scope) {
      scope.maxYear = moment().year()
      scope.changedFields = {}
      scope.changeValue = (field) => {
        if (field === 'ageRating') {
          scope.currentVodState.$ageRatingType = 'countryBased'
        }
        scope.currentVodState[field] = scope.moviedb[field]
        scope.changedFields[field] = true
      }
      scope.imageUrlFor = (url, size) => {
        return url
          ? url.replace('{{size}}', size)
          : ''
      }

      scope.clear = (field) => {
        scope.currentVodState[field] = scope.vod[field]
        scope.changedFields[field] = false
      }

      scope.cancel = () => {
        scope.moviedb = null
      }

      scope.autoFill = () => {
        scope.currentVodState.$ageRatingType = 'countryBased'
        Object.keys(scope.moviedb).forEach(key => {
            scope.currentVodState[key] = scope.moviedb[key]
            scope.changedFields[key] = true
        })
      }
    },
    template: /* html */ `
      <div class="moviedb">
        <form class="form-horizontal" name="vodForm" novalidate ng-submit="vodForm.$valid && update('fromTMDB', vodForm)">
          <div class="row mb-15">
            <div class="col-sm-6">
              <p>Search result for "{{search.title || moviedb.name}}"</p>
              <p>ID {{moviedb.tmdbId}}</p>
            </div>
           
            <div class="col-sm-5 col-sm-offset-1">
              <p>Vod Information</p>
              <button class="btn btn-primary" type="button" ng-click="autoFill()">Autofill</button>
            </div>
          </div>
          <div class="row mb-15">
            <div class="col-sm-2">Title:</div>
            <div class="col-sm-4 bordered">
              <input-with-counter input-class="form-control" name="title" value="moviedb.name"
               placeholder="Title"></input-with-counter>
            </div>
            <div class="col-sm-1 changer">
                <i class="far fa-exchange" ng-click="changeValue('name')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div ng-class="{'has-error': (vodForm.name.$touched || vodForm.$submitted) && vodForm.name.$invalid}">
                <input-with-counter input-class="form-control" name="name" value="currentVodState.name"
                  form="vodForm" placeholder="Movie" max-length="80" field-required="true"></input-with-counter>
              </div>
              <div class="text-danger" ng-messages="vodForm.name.$error"
                ng-show="vodForm.name.$touched || vodForm.$submitted">
                <p ng-message="required">Title is required</p>
                <p ng-message="maxlength">Title is too long</p>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.name" ng-click="clear('name')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>
          <div class="row mb-15">
            <div class="col-sm-2">Trailer Image:</div>
            <div class="col-sm-4 bordered">
              <div class="imgUpload">
                <div class="imgUpload__box">
                  <div class="uploadedImg">
                    <img ng-src="{{imageUrlFor(moviedb.imageUrl, '530x720')}}" alt="" />
                  </div>
                  <dndfile class="imgUpload__poster" ng-class="{'hasPic': imageUrlFor(moviedb.imageUrl, '530x720')}"
                    data-text="Vertical Poster 530x720" data accept=".jpg,.png,.jpeg,.webp"
                    on-file="vm.uploadPortrait" promise  disabled="true" />
                </div>
              </div>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('imageUrl')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div class="imgUpload">
                <div class="imgUpload__box">
                  <div class="uploadedImg" ng-if="currentVodState.imageUrl">
                    <img ng-src="{{imageUrlFor(currentVodState.imageUrl, '530x720')}}" alt="" />
                  </div> 
                  <div class="uploadedImg" ng-if="!currentVodState.imageUrl">
                    <img ng-src="{{imageUrlFor(currentVodState.imageUrl, '530x720')}}" alt="" />
                  </div>
                  <dndfile class="imgUpload__poster" ng-class="{'hasPic': imageUrlFor(currentVodState.imageUrl, '530x720')}"
                    data-text="Vertical Poster 530x720" data accept=".jpg,.png,.jpeg,.webp"
                    on-file="currentVodState.imageUrl" promise  disabled="true" />
                </div>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.imageUrl" ng-click="clear('imageUrl')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>
          <div class="row mb-15">
            <div class="col-sm-4 col-sm-offset-2 bordered">  
              <div class="imgUpload">
                <div class="imgUpload__box imgUpload--column">
                  <div class="imgUpload__box--imgWrapper">
                    <div class="uploadedImg">
                      <img ng-src="{{imageUrlFor(moviedb.imageBackgroundUrl, '1280x720')}}" alt="" />
                    </div>
                    <dndfile class="imgUpload__horizontal" ng-class="{'hasPic': imageUrlFor(moviedb.imageBackgroundUrl, '1280x720')}"
                      data-text="Background Image 1280x720" data accept=".jpg,.png,.jpeg,.webp"
                      on-file="vm.uploadPortrait" promise  disabled="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('imageBackgroundUrl')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div class="imgUpload">
                <div class="imgUpload__box imgUpload--column">
                  <div class="imgUpload__box--imgWrapper">
                    <div class="uploadedImg">
                      <img ng-src="{{imageUrlFor(currentVodState.imageBackgroundUrl, '1280x720')}}" alt="" />
                    </div>
                    <dndfile class="imgUpload__horizontal" ng-class="{'hasPic': imageUrlFor(currentVodState.imageBackgroundUrl, '1280x720')}"
                      data-text="Background Image 1280x720" data accept=".jpg,.png,.jpeg,.webp"
                      on-file="vm.uploadPortrait" promise  disabled="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.imageBackgroundUrl" ng-click="clear('imageBackgroundUrl')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>         
          <div class="row mb-15">
            <div class="col-sm-4 col-sm-offset-2 bordered">
              <div class="imgUpload">
                <div class="imgUpload__box imgUpload--column">
                  <div class="imgUpload__box--imgWrapper">
                    <div class="uploadedImg">
                      <img ng-src="{{imageUrlFor(moviedb.imageHorizontalUrl, '1280x720')}}" alt="" />
                    </div>
                    <dndfile class="imgUpload__horizontal" ng-class="{'hasPic': imageUrlFor(moviedb.imageHorizontalUrl, '800x542')}"
                      data-text="Horizontal Image 800x542" data accept=".jpg,.png,.jpeg,.webp"
                      on-file="vm.uploadPortrait" promise  disabled="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('imageHorizontalUrl')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div class="imgUpload">
                <div class="imgUpload__box imgUpload--column">
                  <div class="imgUpload__box--imgWrapper">
                    <div class="uploadedImg">
                      <img ng-src="{{imageUrlFor(currentVodState.imageHorizontalUrl, '1280x720')}}" alt="" />
                    </div> 
                    <dndfile class="imgUpload__horizontal" ng-class="{'hasPic': imageUrlFor(currentVodState.imageHorizontalUrl, '800x542')}"
                      data-text="Horizontal Image 800x542" data accept=".jpg,.png,.jpeg,.webp"
                      on-file="vm.uploadPortrait" promise  disabled="true" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.imageHorizontalUrl" ng-click="clear('imageHorizontalUrl')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>    
          <div class="row mb-15">
            <div class="col-sm-2">Description:</div>
            <div class="col-sm-4 bordered">
              <textarea-with-counter input-class="form-control" name="description" value="moviedb.description"
                rows="5" placeholder="Description"></textarea-with-counter>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('description')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div ng-class="{'has-error': (vodForm.description.$touched || vodForm.$submitted) && vodForm.description.$invalid}">
                <textarea-with-counter input-class="form-control" name="description" value="currentVodState.description"
                  form="vodForm" max-length="500" rows="5" placeholder="Description"></textarea-with-counter> 
              </div>
              <div class="text-danger" ng-messages="vodForm.description.$error"
                ng-show="vodForm.description.$touched || vodForm.$submitted">
                <p ng-message="maxlength">Description is too long</p>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.description" ng-click="clear('description')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>         
          <div class="row mb-15">
            <div class="col-sm-2">Directors:</div>
            <div class="col-sm-4 bordered">
              <input-with-counter input-class="form-control" name="directors" value="moviedb.directors"
                placeholder="Directors"></input-with-counter>
            </div>
            <div class="col-sm-1 changer" ng-click="changeValue('directors')">
              <i class="far fa-exchange" ></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div ng-class="{'has-error': (vodForm.directors.$touched || vodForm.$submitted) && vodForm.directors.$invalid}">
                <input-with-counter input-class="form-control" name="directors" value="currentVodState.directors"
                  form="vodForm" placeholder="Directors" max-length="255"></input-with-counter>
              </div>
              <div class="text-danger" ng-messages="vodForm.directors.$error"
                ng-show="vodForm.directors.$touched || vodForm.$submitted">
                <p ng-message="maxlength">Directors is too long</p>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.directors" ng-click="clear('directors')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>     
          <div class="row mb-15">
            <div class="col-sm-2">Stars:</div>
            <div class="col-sm-4 bordered">
              <input-with-counter input-class="form-control" name="stars" value="moviedb.stars"
                placeholder="Stars"></input-with-counter>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('stars')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <div ng-class="{'has-error': (vodForm.stars.$touched || vodForm.$submitted) && vodForm.stars.$invalid}">
                <input-with-counter input-class="form-control" name="stars" value="currentVodState.stars"
                  form="vodForm" placeholder="Stars" max-length="255"></input-with-counter>
              </div>
              <div class="text-danger" ng-messages="vodForm.stars.$error"
                ng-show="vodForm.stars.$touched || vodForm.$submitted">
                <p ng-message="maxlength">Stars is too long</p>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.stars" ng-click="clear('stars')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>     
          <div class="row mb-15">
            <div class="col-sm-2">Year:</div>
            <div class="col-sm-4 bordered">
              <input type="number" class="form-control vod-year-input" name="year" 
                placeholder="e.g. 1998" ng-model="moviedb.year" min="1888" max="{{scope.maxYear}}"
                pattern="\\d*">
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('year')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
              <input type="number" class="form-control vod-year-input" name="year" 
                placeholder="e.g. 1998" ng-model="currentVodState.year" min="1888" max="{{scope.maxYear}}"
                pattern="\\d*">
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.year" ng-click="clear('year')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>   
          <div class="row mb-15">
            <div class="col-sm-2">Age Ratings:</div>
            <div class="col-sm-4 bordered">
              <div class="col-sm-2">
                {{search.countryForAR.name}}
              </div>
              <div class="col-sm-10 non-bordered">
                  <input-with-counter input-class="form-control" name="ageRating" value="moviedb.ageRating.rating"
                    placeholder="Rating"></input-with-counter>
              </div>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('ageRating')"></i>
            </div>
            <div class="col-sm-4 bordered colored" ng-if="currentVodState.$ageRatingType === 'default'">
              <input-with-counter input-class="form-control" name="ageRating" value="currentVodState.$defaultAgeRating.rating" form="vodForm"
                max-length="255" placeholder="Ratings"></input-with-counter>
            </div>
            <div class="col-sm-4 bordered colored" ng-if="currentVodState.$ageRatingType !== 'default'">
              <input-with-counter input-class="form-control" name="ageRating" value="currentVodState.ageRating.rating" form="vodForm"
                max-length="255" placeholder="Ratings"></input-with-counter>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.ageRating" ng-click="clear('ageRating')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>   
          <div class="row mb-15">
            <div class="col-sm-2">Length:</div>
            <div class="col-sm-4 bordered">
              <input-with-counter input-class="form-control" name="length" value="moviedb.length"
                placeholder="Length"></input-with-counter>
            </div>
            <div class="col-sm-1 changer">
              <i class="far fa-exchange" ng-click="changeValue('length')"></i>
            </div>
            <div class="col-sm-4 bordered colored">
               <div ng-class="{'has-error': (vodForm.length.$touched || vodForm.$submitted) && vodForm.length.$invalid}">
                <input-with-counter input-class="form-control" name="length" value="currentVodState.length"
                  form="vodForm" placeholder="Length" max-length="80"></input-with-counter>
              </div>
              <div class="text-danger" ng-messages="vodForm.length.$error"
                ng-show="vodForm.length.$touched || vodForm.$submitted">
                <p ng-message="maxlength">Length is too long</p>
              </div>
            </div>
            <div class="col-sm-1 changer" style="margin-top: 25px">
              <button title="Clear field" class="btn btn-xs btn-danger delete-btn" ng-if="changedFields.length" ng-click="clear('length')"><span class="far fa-minus-circle"></span></button>
            </div>
          </div>        
          <div class="row mb-15">
          <div class="col-sm-3 col-sm-offset-7">
            <fieldset>
              <button type="submit" class="btn btn-primary">Update</button>
              <a href="#" class="btn btn-default" ng-click="cancel()">Cancel</a>
            </fieldset>
          </div>
        </div>    
        </form>    
      </div>

    `
  }
}
